import * as React from 'react';
function SvgWarning(props) {
    return (<svg width={30} height={30} {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#EDB807" cx={15} cy={15} r={15}/>
        <path d="M15 18a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm1.359-9l-.398 7.633h-1.906L13.656 9h2.703z" fill="#FFF" fillRule="nonzero"/>
      </g>
    </svg>);
}
export default SvgWarning;
